module.exports = __webpack_public_path__ + "img/baggage1.43ab7336.png";